export default __webpack_public_path__ + "static/media/whatsapp_chat_dummy.6fbd4713.png";